import { DateTimeFormat } from './date-time-format';
import { BrowserTime } from './timezone/browser-time';
import { Offset } from './timezone/offset';
import { ServerTime } from './timezone/server-time';
import { UserTime } from './timezone/user-time';
import { type MainDateTimezoneApi } from './timezone/types';

export { DateTimeFormat };
export { DurationFormat } from './duration-format';

// Compatibility alias. A value, not a re-export: the declarations keep the class under its own name
// and do not shadow the global Date type in the BX.Main namespace.
export const Date: typeof DateTimeFormat = DateTimeFormat;

export const Timezone: MainDateTimezoneApi = Object.freeze({
	BrowserTime,
	Offset,
	ServerTime,
	UserTime,
});
